import { Box, Breakpoint, Container, SxProps, Theme, Toolbar } from '@mui/material';
import React from 'react';

import SiteHeader from 'components/SiteHeader/SiteHeader';
import DashboardFooter from 'components/StudiesDashboard/DashboardFooter';
import { MainPageAnnotationDrawer } from '../../AssignmentsList/MainPageAnnotationDrawer';
import { FlexBody } from '../FlexContainers/FlexContainers';

interface WrapPageScopedSx {
  rootSx?: SxProps<Theme>;
  bodySx?: SxProps<Theme>;
}

const wrapPage = (
  WrappedComponent: React.FunctionComponent<React.PropsWithChildren<unknown>>,
  containerSx: SxProps<Theme> = {},
  containerMaxWidth: false | Breakpoint = 'lg',
  scopedSx: WrapPageScopedSx = {}
) => {
  const WrapPageComponent: React.FunctionComponent<React.PropsWithChildren<unknown>> = (props) => {
    return (
      <Box
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          },
          ...(Array.isArray(scopedSx.rootSx) ? scopedSx.rootSx : scopedSx.rootSx ? [scopedSx.rootSx] : []),
        ]}
      >
        <FlexBody sx={scopedSx.bodySx}>
          <SiteHeader />
          <Toolbar />
          <Container sx={containerSx} maxWidth={containerMaxWidth}>
            <WrappedComponent {...props} />
          </Container>
          <MainPageAnnotationDrawer />
        </FlexBody>
        <DashboardFooter />
      </Box>
    );
  };

  return WrapPageComponent;
};

export default wrapPage;
